import React, { useState, useEffect } from 'react';

function YesNoQuestion({ question, value = '', onChange }) {
  const [answer, setAnswer] = useState(value);

  // Update local state when value prop changes (new question)
  useEffect(() => {
    setAnswer(value);
  }, [value, question.id]);

  const handleAnswer = (selectedAnswer) => {
    setAnswer(selectedAnswer);
    onChange(selectedAnswer);
  };

  return (
    <div className="yes-no-question">
      <h3>{question.text}</h3>
      {question.description && <p className="question-description">{question.description}</p>}
      
      {question.definition && (
        <div className="definition-box">
          <strong>Definition:</strong> {question.definition}
        </div>
      )}
      
      {question.risks && (
        <div className="risks-box">
          <strong>Risks:</strong> {question.risks}
        </div>
      )}
      
      <div className="yes-no-buttons">
        <button 
          className={`answer-button ${answer === 'Yes' ? 'selected' : ''}`}
          onClick={() => handleAnswer('Yes')}
        >
          Yes
        </button>
        <button 
          className={`answer-button ${answer === 'No' ? 'selected' : ''}`}
          onClick={() => handleAnswer('No')}
        >
          No
        </button>
      </div>
    </div>
  );
}

export default YesNoQuestion;